import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Button, Divider, ScrollSpy } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import {
  Container,
  LeftMarginSection,
  MarginSection,
} from 'common/modules/bidBanner/container'
import * as AuctionDuration from 'common/modules/bidBanner/auctionDuration'
import {
  CountdownBefore,
  getServerTimeMoment,
  getStartTimeMoment,
} from 'common/modules/auctionCountdown'
import * as BidDetails from 'common/modules/bidBanner/bidDetails'
import FAQLink from 'common/modules/bidBanner/faqSection/faqLink'
import CalendarPopup from 'common/modules/auctionDetails/states/calendar'
import Header from 'common/modules/bidBanner/header'

const cx = classnames.bind({})

const Scheduled = () => {
  const { segment } = useListingContext()

  if (!segment) return null

  const renderLeft = () => (
    <>
      <div className={cx('u-mb-3')}>
        <AuctionDuration.Compact
          startDateTime={segment?.start_date}
          endDateTime={segment.initial_end_date}
        />
      </div>
      <div className={cx('u-mb-3')}>
        <Header
          color='adcLightBlue'
          icon={<Header.IconGavel color='adcLightBlue' />}
          text='The auction is scheduled.'
        />
      </div>
      <LeftMarginSection>
        <BidDetails.During />
      </LeftMarginSection>
      <MarginSection left right>
        <Divider />
        <div
          style={{ display: 'flex', justifyContent: 'space-between' }}
          data-elm-id='faq_section'
        >
          <FAQLink />
          <CalendarPopup />
          <ScrollSpy selector='#prepare_your_finances'>
            {({ scrollTo }: { scrollTo: () => void }) => (
              <a onClick={scrollTo} data-elm-id='prepare_for_auction_cta'>
                Prepare for the auction
              </a>
            )}
          </ScrollSpy>
        </div>
      </MarginSection>
    </>
  )

  const renderRight = () => (
    <>
      <div className={cx('u-mb-6')}>
        <CountdownBefore
          endTime={getStartTimeMoment(segment)}
          currentServerTime={getServerTimeMoment(segment)}
        />
      </div>
      <div className={cx('u-mb-3')}>
        <Button role='primary' isStretch disabled elmId='bid_button_disabled'>
          Place Bid
        </Button>
      </div>
    </>
  )

  return (
    <Container
      ribbonColor='adcLightBlue'
      left={renderLeft()}
      right={renderRight()}
    />
  )
}

export default Scheduled
